"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePagination = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const pagination_utils_1 = require("./pagination.utils");
const localization_1 = require("../../localization");
const TablePagination = ({ itemsCount, pageNumber, perPageLabel = 'PAGINATION_PER_PAGE_LABEL', rowsPerPage, rowsPerPageOptions, onPageChange, onRowsPerPageChange, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { pagesCount } = (0, pagination_utils_1.getPaginationValues)({ itemsCount, pageNumber, pageSize: rowsPerPage });
    return (react_1.default.createElement(ui_components_1.TablePagination, { pagesCount: pagesCount, currentPage: pageNumber, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, handlePageChange: onPageChange, handleRowsPerPageChange: (newRows) => onRowsPerPageChange(newRows), pageLabel: `${t({ key: 'PAGINATION_PAGE_LABEL' })}:`, perPageLabel: `${t({ key: perPageLabel })}:`, pageCountLabel: t({ key: 'PAGINATION_COUNT_LABEL', values: { numPages: pagesCount } }), paginationCurrentRangeLabel: t({ key: 'PAGINATION_CURRENT_OF_LABEL', values: { total: itemsCount } }) }));
};
exports.TablePagination = TablePagination;
exports.default = exports.TablePagination;
